import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Order } from "src/app/shared/models/order.model";
import { ChatTask } from "src/app/shared/models/chat.model";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "chat-tasks",
  templateUrl: "./chat-tasks.component.html",
  styleUrls: ["./chat-tasks.component.sass"],
  imports: [TableComponent, TranslateModule, CommonModule],
  standalone: true,
})
export class ChatTasksComponent implements OnInit {
  @Input() order: Order;
  @Output() onEditTask = new EventEmitter<ChatTask>();
  @Output() onCreateTask = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  editTask(task: ChatTask) {
    this.onEditTask.emit(task);
  }

  createTask() {
    this.onCreateTask.emit();
  }
}
